module.exports = __webpack_public_path__ + "static/img/Course-duration.5b5e6f19.png";